import globalStyles from "../../../styles/globalStyles.module.css";
import { useNavigate } from "react-router-dom";

const CancelButton = () => {
  const navigate = useNavigate();
  const handleCancel = () => {
    navigate(-1);
    // Logic to handle cancel action
    console.log("Cancel button clicked");
  };

  return (
    <button className={globalStyles.button} onClick={handleCancel}>
      Cancel
    </button>
  );
};

export default CancelButton;
